<template>
  <v-btn
    v-if="dividing"
    fab
    small
    depressed
    color="primary"
    class="ml-3 font-weight-bold"
    :class="{'text-button': customers < 10}"
    @click="reset"
  >
    {{ customer }}/{{ customers }}
  </v-btn>
  <h-numeric-menu
    v-else
    :value="customers"
    :title="__('splitBy')"
    display="10"
    light
    color="grey lighten-4"
    @input="divide"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        fab
        small
        depressed
        color="secondary"
        class="ml-3"
        :disabled="! $store.getters['orders/payment/standard']"
      >
        <v-icon v-text="icons.divide" />
      </v-btn>
    </template>
  </h-numeric-menu>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HNumericMenu from '@/Components/NumericMenu'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HNumericMenu,
    },

    computed: {
      ...mapState('orders/payment/divide', [
        'customer',
        'customers',
      ]),
      ...mapGetters('orders/payment', [
        'dividing',
      ]),
    },

    methods: {
      ...mapActions('orders/payment', [
        'divide',
        'reset',
      ]),
    },
  }
</script>
